import React from 'react';
import PropTypes from 'prop-types';
import ContainerStyled from './style/PaymentMethodsStyled';
import {
  AgainstBalanceMethod,
  InvoiceMethod,
  WebpayMethod,
  WompayMethod,
} from './Method';
import OtherMethodOfPay from './Method/OtherMethodOfPay';
import useOtherLines from '../../../../../hooks/useOtherLines';
import { useGlobalData } from '../../../../../contextProvider/GlobalDataContext';

const PaymentMethods = ({
  availableMethods,
  segment,
  balance,
  wompayCard,
  bundlePrice,
  buyCallback,
  isRecurring,
  disabled,
  paymentType,
}) => {
  const getComponent = paymentMethod => {
    const { isEnabled = { rcf: false } } = useGlobalData();
    const isRCFEnabled = isEnabled.rcf;

    const { isOtherLines, segment: segmentOtherLines } = useOtherLines();
    const otherThanPostpaid = segment.toUpperCase() !== 'POSTPAID';
    const otherThanPrepaid = segment.toUpperCase() !== 'PREPAID';
    const isWebpay = paymentMethod === 'WEBPAY';
    const isWompay = paymentMethod === 'WOMPAY';
    const isOtherMethodPay = paymentMethod === 'OTRAS_FORMAS_PAGO';
    const isAgainstBalance =
      paymentMethod === 'CONTRASALDO' && otherThanPostpaid;
    const isInvoice = paymentMethod === 'CONTRAFACTURA' && otherThanPrepaid;
    if (isWebpay) {
      return (
        <WebpayMethod key={paymentMethod} buyCallback={buyCallback} active />
      );
    }
    if (isOtherMethodPay) {
      return (
        <OtherMethodOfPay key={paymentMethod} price={bundlePrice} active />
      );
    }

    if (isWompay) {
      return (
        <WompayMethod
          wompayCard={wompayCard}
          key={paymentMethod}
          buyCallback={buyCallback}
          active
        />
      );
    }

    if (isAgainstBalance) {
      return (
        <AgainstBalanceMethod
          key={paymentMethod}
          buyCallback={buyCallback}
          balance={balance}
          bundlePrice={bundlePrice}
          isRecurring={isRecurring}
        />
      );
    }

    if (isInvoice) {
      if (
        (isOtherLines &&
          isRCFEnabled &&
          segmentOtherLines !== 'POSTPAID' &&
          segmentOtherLines !== 'HYBRID') ||
        !isOtherLines
      ) {
        return (
          <InvoiceMethod
            key={paymentMethod}
            buyCallback={buyCallback}
            disabled={disabled}
            paymentType={paymentType}
          />
        );
      }
    }

    return null;
  };

  return (
    <ContainerStyled>
      {availableMethods.map(method => {
        return getComponent(method);
      })}
    </ContainerStyled>
  );
};

PaymentMethods.propTypes = {
  availableMethods: PropTypes.arrayOf(PropTypes.string).isRequired,
  segment: PropTypes.string.isRequired,
  balance: PropTypes.number.isRequired,
  wompayCard: PropTypes.shape({
    maxAmount: PropTypes.number,
    patActivated: PropTypes.bool,
    id: PropTypes.string,
    name: PropTypes.string,
    lastname: PropTypes.string,
    lastFour: PropTypes.string,
    vendor: PropTypes.string,
  }).isRequired,
  bundlePrice: PropTypes.string.isRequired,
  buyCallback: PropTypes.func.isRequired,
  isRecurring: PropTypes.bool,
  disabled: PropTypes.bool,
  paymentType: PropTypes.string,
};

PaymentMethods.defaultProps = {
  isRecurring: false,
  disabled: true,
  paymentType: 'bolsa',
};

export default PaymentMethods;
